// Module
var code = `<div class="svc-rating-question-content">
  <div data-bind="class: controlsClassNames">
    <!-- ko if: allowRemove -->
    <sv-svg-icon data-bind="class: removeClassNames, click: removeItem, key2click, attr: { 'aria-label': removeTooltip }" params="iconName: 'icon-remove_16x16', size: 'auto', title: removeTooltip">
    </sv-svg-icon>
    <!-- /ko -->
    <!-- ko if: allowAdd -->
    <sv-svg-icon data-bind="class: addClassNames, click: addItem, key2click, attr: { 'aria-label': addTooltip }" params="iconName: 'icon-add_16x16', size: 'auto', title: addTooltip">
    </sv-svg-icon>
    <!-- /ko -->
  </div>
  <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
  <!-- /ko -->
</div>`;
// Exports
export default code;